import React from 'react';

const AdminHeader = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <div className="bg-white px-4 sm:px-6 py-4 sm:py-5 border-b border-[#50505066]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Mobile Menu Button */}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <div className="hidden md:block">
            <h1 className="text-[20px] sm:text-[24px] lg:text-[28px] leading-[30px] sm:leading-[36px] lg:leading-[42px] tracking-[-0.72px] font-semibold text-black poppins">
              Good to see you, Michelle!
            </h1>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] leading-[20px] sm:leading-[24px] lg:leading-[27px] text-[#B9BCC6] tracking-[-0.36px] mt-1.5 poppins font-normal">
              Improve your sales management for better growth
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 sm:gap-6">
          <div className="relative hidden sm:block">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_24_81)">
                  <path
                    d="M20.6665 19.1667H19.6132L19.2399 18.8067C20.8399 16.94 21.6665 14.3933 21.2132 11.6867C20.5865 7.98 17.4932 5.02 13.7599 4.56667C8.11986 3.87334 3.37319 8.62 4.06652 14.26C4.51986 17.9933 7.47986 21.0867 11.1865 21.7133C13.8932 22.1667 16.4399 21.34 18.3065 19.74L18.6665 20.1133V21.1667L24.3332 26.8333C24.8799 27.38 25.7732 27.38 26.3199 26.8333C26.8665 26.2867 26.8665 25.3933 26.3199 24.8467L20.6665 19.1667ZM12.6665 19.1667C9.34652 19.1667 6.66652 16.4867 6.66652 13.1667C6.66652 9.84667 9.34652 7.16667 12.6665 7.16667C15.9865 7.16667 18.6665 9.84667 18.6665 13.1667C18.6665 16.4867 15.9865 19.1667 12.6665 19.1667Z"
                    fill="#7F7C7C"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_24_81">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search anything..."
              className="w-[200px] lg:w-[241px] pl-[56px] pr-4 py-2 border border-[#7777774D] bg-[#E8E8E8] rounded-[14px] placeholder:text-[#7F7C7C] tracking-[-0.72px] text-[16px] lg:text-[18px] leading-[24px] lg:leading-[27px] font-normal poppins outline-none"
            />
          </div>

          <div className="flex items-center gap-2 sm:gap-4">
            <button className="p-2 sm:p-0">
              <img
                src="/assets/admin/notification.svg"
                alt="notification"
                className="w-6 h-6 sm:w-auto sm:h-auto"
              />
            </button>

            <div className="flex items-center">
              <img
                src="/assets/admin/profile.png"
                alt="profile"
                className="w-8 h-8 sm:min-w-[44px] sm:h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
